module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALgAAAAEAQMAAAAH9WeKAAAABlBMVEUAAAD///+l2Z/dAAAAAXRSTlMAQObYZgAAABBJREFUCNdjqP+PDfyjljgAuXxZoXtgcS8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/positionTopLine.png
// module id = MdAz
// module chunks = 2